// extracted by mini-css-extract-plugin
export default {"stakeTime":"CLOfWpvGHSSct15le85v","utc":"pSQmrjyY77PAjIMrRhwN","common_bganimation":"GvZjeUP7596RDI_gT8yT"};